import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/core/Checkbox.atom';
import { HoverTooltip } from '@/core/HoverTooltip.atom';
import { TimeZoneSelector } from '@/core/TimeZoneSelector.molecule';
import type { Timezone } from '@/datetime/timezone.service';

interface TimezoneModalContentProps {
  extraClassNames?: string;
  timezone: Timezone;
  fixed: boolean;
  userFallback: boolean;
  setTimezone: (timezone: Timezone) => void;
  setFixed: (fixed: boolean) => void;
  openUserPreferences: () => void;
}

export const TimezoneModalContent = ({
  extraClassNames = '',
  timezone,
  fixed,
  userFallback,
  setTimezone,
  setFixed,
  openUserPreferences,
}: TimezoneModalContentProps) => {
  const { t } = useTranslation();

  return (
    <div className={`tw:p-4 ${extraClassNames}`}>
      <div className="mb15">
        {t(userFallback ? 'TIME_ZONE_MODAL.DESCRIPTION_WORKSHEET' : 'TIME_ZONE_MODAL.DESCRIPTION_TOPIC')}
      </div>
      <div className="flexRowContainer mb0">
        <div id="timezoneLocal" className="flexColumnContainer flexSpaceBetween flexAlignCenter">
          <Checkbox
            type="radio"
            id="setTimeZoneFlex"
            isChecked={!fixed}
            onClick={() => setFixed(false)}
            tooltip={userFallback ? 'TIME_ZONE_MODAL.USER_TOOLTIP' : 'TIME_ZONE_MODAL.NOT_CONFIGURED_TOOLTIP'}
            label={userFallback ? 'TIME_ZONE_MODAL.USER' : 'TIME_ZONE_MODAL.NOT_CONFIGURED'}
          />
          {userFallback && (
            <HoverTooltip text="TIME_ZONE_MODAL.EDIT_PREFERENCES_TOOLTIP" placement="right">
              <a
                type="button"
                className="ml5 mr8 cursorPointer font-size-smaller text-italic sq-text-primary text-underline"
                onClick={openUserPreferences}>
                {t('TIME_ZONE_MODAL.EDIT_PREFERENCES')}
              </a>
            </HoverTooltip>
          )}
        </div>
        <div id="timezoneWorksheet" className="flexRowContainer mt2" onClick={() => setFixed(true)}>
          <Checkbox
            type="radio"
            id="setTimeZoneFixed"
            isChecked={fixed}
            onClick={() => setFixed(true)}
            tooltip={userFallback ? 'TIME_ZONE_MODAL.FIXED_TOOLTIP' : 'TIME_ZONE_MODAL.FIXED_TOPIC_TOOLTIP'}
            label="TIME_ZONE_MODAL.FIXED"
          />
          <HoverTooltip
            placement="right"
            text={userFallback ? 'TIME_ZONE_MODAL.FIXED_TOOLTIP' : 'TIME_ZONE_MODAL.FIXED_TOPIC_TOOLTIP'}>
            <div className="tw:mt-2 tw:ml-5">
              <TimeZoneSelector timezone={timezone} onSelect={setTimezone} />
            </div>
          </HoverTooltip>
        </div>
      </div>
    </div>
  );
};
